// Leaving this last declared experiment in the file to show how to add more experiments
// import * as headerCopyExperiment from '../experiments/trade-verbiage';
// import WithExperiment from './WithExperiment';

type ExperimentLoaderProps = {
  children: React.ReactNode;
};

const ExperimentLoader = ({ children }: ExperimentLoaderProps) => (
  <>
    {/* <WithExperiment {...headerCopyExperiment} /> */}
    {children}
  </>
);

export default ExperimentLoader;
